var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "vs-row",
        { staticClass: "mb-6 mt-10" },
        [
          _c("vs-col", { staticClass: "sm:w-1/5 w-full" }, [
            _c("span", [_vm._v("Date :")]),
          ]),
          _vm._v(" "),
          _c(
            "vs-col",
            { staticClass: "sm:w-1/5" },
            [
              _c("Datepicker", {
                attrs: {
                  name: "ratingDate",
                  language: _vm.fr,
                  placeholder: "Date du " + _vm.projectNames.singular,
                  disabled:
                    _vm.typeForm === "validation" ||
                    _vm.typeForm === "consultation",
                  "disabled-dates": _vm.disabledDates,
                  "monday-first": "",
                },
                on: {
                  input: function ($event) {
                    return _vm.updateFormHandle()
                  },
                },
                model: {
                  value: _vm.resource.rating_date,
                  callback: function ($$v) {
                    _vm.$set(_vm.resource, "rating_date", $$v)
                  },
                  expression: "resource.rating_date",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("vs-col", { staticClass: "sm:w-3/5" }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "vs-divider",
        { staticClass: "mt-20 font-bold", attrs: { position: "left" } },
        [
          _c("p", { staticClass: "bold" }, [
            _vm._v("Périmètre des données à prendre en compte :"),
          ]),
        ]
      ),
      _vm._v(" "),
      !_vm.skillReview
        ? _c("vs-alert", { attrs: { color: "#999" } }, [
            _vm._v(
              "\n        L'ajout ou la suppression d'une grille, d'un poste, d'un stage ou d'un métier mettra à jour le parcours de la personne.\n    "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "vs-row",
        { staticClass: "mb-6 mt-10" },
        [
          _c("vs-col", { staticClass: "sm:w-1/5 w-full" }, [
            _c("span", [_vm._v("Expérience(s) à évaluer :")]),
          ]),
          _vm._v(" "),
          _c(
            "vs-col",
            { staticClass: "sm:w-4/5 w-full" },
            [
              _c(
                "Multiselect",
                {
                  attrs: {
                    id: "occupedJobs",
                    options: _vm.jobs,
                    multiple: true,
                    "group-values": "jobs",
                    "group-label": "establishmentService",
                    "group-select": true,
                    placeholder: "Recherche ...",
                    "track-by": "uid",
                    label: "title",
                    "select-label": "",
                    "select-group-label": "",
                    "selected-label": "",
                    "deselect-label": "",
                    "deselect-group-label": "",
                    disabled:
                      _vm.typeForm === "validation" ||
                      _vm.typeForm === "consultation",
                    loading: _vm.jobs.length == 0,
                  },
                  on: {
                    input: function ($event) {
                      _vm.careerUpdatedHandle()
                      _vm.updateFormHandle()
                    },
                  },
                  model: {
                    value: _vm.resource.perimeter_jobs,
                    callback: function ($$v) {
                      _vm.$set(_vm.resource, "perimeter_jobs", $$v)
                    },
                    expression: "resource.perimeter_jobs",
                  },
                },
                [
                  _c(
                    "span",
                    { attrs: { slot: "noResult" }, slot: "noResult" },
                    [_vm._v("Aucun résultat.")]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "vs-row",
        { staticClass: "mb-6 mt-10" },
        [
          _c("vs-col", { staticClass: "sm:w-1/5 w-full" }, [
            _c("span", [_vm._v("Métier(s) à évaluer :")]),
          ]),
          _vm._v(" "),
          _c(
            "vs-col",
            { staticClass: "sm:w-4/5 w-full" },
            [
              _c(
                "Multiselect",
                {
                  attrs: {
                    id: "occupedOccupations",
                    options: _vm.occupations,
                    multiple: true,
                    "group-values": "occupations",
                    "group-label": "type",
                    "group-select": true,
                    placeholder: "Recherche ...",
                    "track-by": "uid",
                    label: "title",
                    "select-label": "",
                    "select-group-label": "",
                    "selected-label": "",
                    "deselect-label": "",
                    "deselect-group-label": "",
                    disabled:
                      _vm.typeForm === "validation" ||
                      _vm.typeForm === "consultation",
                    loading: _vm.occupations.length == 0,
                  },
                  on: {
                    input: function ($event) {
                      _vm.careerUpdatedHandle()
                      _vm.updateFormHandle()
                    },
                  },
                  model: {
                    value: _vm.resource.perimeter_occupations,
                    callback: function ($$v) {
                      _vm.$set(_vm.resource, "perimeter_occupations", $$v)
                    },
                    expression: "resource.perimeter_occupations",
                  },
                },
                [
                  _c(
                    "span",
                    { attrs: { slot: "noResult" }, slot: "noResult" },
                    [_vm._v("Aucun résultat.")]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "vs-row",
        { staticClass: "mb-6 mt-10" },
        [
          _c("vs-col", { staticClass: "sm:w-1/5 w-full" }, [
            _c("span", [_vm._v("Autres savoir-faire :")]),
          ]),
          _vm._v(" "),
          _c(
            "vs-col",
            { staticClass: "sm:w-4/5 w-full" },
            [
              _c(
                "vs-row",
                [
                  _c(
                    "vs-col",
                    { staticClass: "p-0", attrs: { "vs-w": "9" } },
                    [
                      _c(
                        "Multiselect",
                        {
                          attrs: {
                            id: "occupationSkillPerimeter",
                            options: _vm.occupationSkills.data,
                            multiple: true,
                            "group-values": "items",
                            "group-label": "group",
                            "group-select": true,
                            placeholder: "Recherche ...",
                            "track-by": "id",
                            label: "title",
                            "select-label": "",
                            "select-group-label": "",
                            "selected-label": "",
                            "deselect-label": "",
                            "deselect-group-label": "",
                            disabled:
                              _vm.typeForm === "validation" ||
                              _vm.typeForm === "consultation",
                            loading: _vm.occupationSkills.loading,
                          },
                          on: {
                            input: function ($event) {
                              _vm.careerUpdatedHandle()
                              _vm.updateFormHandle()
                            },
                          },
                          model: {
                            value: _vm.resource.perimeter_occskills,
                            callback: function ($$v) {
                              _vm.$set(_vm.resource, "perimeter_occskills", $$v)
                            },
                            expression: "resource.perimeter_occskills",
                          },
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "noResult" }, slot: "noResult" },
                            [_vm._v("Aucun résultat.")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "vs-col",
                    {
                      staticClass:
                        "pl-0 text-right text-nowrap pt-2 text-primary",
                      attrs: { "vs-w": "3" },
                    },
                    [
                      _c(
                        "vs-button",
                        {
                          attrs: { color: "primary", type: "flat" },
                          on: {
                            click: function ($event) {
                              _vm.showPopupExpress = true
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        + Ajouter un savoir-faire\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "DialogPrompt",
                        {
                          attrs: {
                            active: _vm.showPopupExpress,
                            title: "Ajout express",
                            "cancel-text": "Fermer",
                            "accept-text": "Créer les savoir-faire",
                            "button-accept": "filled",
                            "is-valid": !_vm.formExpressError,
                          },
                          on: {
                            "update:active": function ($event) {
                              _vm.showPopupExpress = $event
                            },
                            cancel: _vm.resetResourceExpress,
                            accept: _vm.storeResourceExpress,
                            close: _vm.resetResourceExpress,
                          },
                        },
                        [
                          _c("OccupationSkillExpressForm", {
                            attrs: { withoutSource: true },
                            on: { error: _vm.setFormExpressError },
                            model: {
                              value: _vm.resourcesExpress,
                              callback: function ($$v) {
                                _vm.resourcesExpress = $$v
                              },
                              expression: "resourcesExpress",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "vs-divider",
        { staticClass: "mt-20 font-bold", attrs: { position: "left" } },
        [_c("p", { staticClass: "bold" }, [_vm._v(" ")])]
      ),
      _vm._v(" "),
      _c("vs-alert", { attrs: { color: "#999" } }, [
        _vm._v(
          "\n        Les évaluations sélectionnées sont utilisables dans l'évaluation.\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "vs-row",
        { staticClass: "mb-6 mt-10" },
        [
          _c("vs-col", { staticClass: "sm:w-1/5 w-full" }, [
            _c("span", [_vm._v("Auto-évaluation Portail :")]),
          ]),
          _vm._v(" "),
          _c(
            "vs-col",
            { staticClass: "sm:w-4/5 w-full" },
            [
              _c(
                "Multiselect",
                {
                  attrs: {
                    options: _vm.personalRatings,
                    placeholder: "Recherche ...",
                    "track-by": "title",
                    label: "title",
                    "select-label": "",
                    "select-group-label": "",
                    "selected-label": "",
                    "deselect-label": "",
                    "deselect-group-label": "",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.updateFormHandle()
                    },
                  },
                  model: {
                    value: _vm.resource.personals,
                    callback: function ($$v) {
                      _vm.$set(_vm.resource, "personals", $$v)
                    },
                    expression: "resource.personals",
                  },
                },
                [
                  _c(
                    "span",
                    { attrs: { slot: "noOptions" }, slot: "noOptions" },
                    [_vm._v("Aucune auto-évaluation Portail effectuée")]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "vs-row",
        {
          attrs: {
            "vs-align": "left",
            "vs-type": "flex",
            "vs-justify": "space-around",
            "vs-w": "12",
          },
        },
        [
          false
            ? _c(
                "vs-col",
                {
                  attrs: {
                    "vs-type": "flex",
                    "vs-justify": "left",
                    "vs-align": "left",
                    "vs-w": "7",
                  },
                },
                [
                  _c("p", { staticClass: "bold" }, [
                    _vm._v(
                      "\n                Souhaitez-vous récupérer dans ce projet les évaluations\n                internes/externes saisies sur le Portail ?\n            "
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showEvaluations
        ? _c(
            "vs-row",
            { staticClass: "mb-6 mt-10" },
            [
              _c("vs-col", { staticClass: "sm:w-1/5 w-full" }, [
                _c("span", [_vm._v("Evaluation(s) Portail (2 max) :")]),
              ]),
              _vm._v(" "),
              _c(
                "vs-col",
                { staticClass: "sm:w-4/5 w-full" },
                [
                  _c(
                    "Multiselect",
                    {
                      attrs: {
                        id: "externalRatings",
                        max: 2,
                        options: _vm.externalRatings,
                        multiple: true,
                        placeholder: "Recherche ...",
                        "track-by": "id",
                        label: "title",
                        "select-label": "",
                        "select-group-label": "",
                        "selected-label": "",
                        "deselect-label": "",
                        "deselect-group-label": "",
                        disabled:
                          _vm.typeForm === "validation" ||
                          _vm.typeForm === "consultation",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.updateFormHandle()
                        },
                      },
                      model: {
                        value: _vm.resource.externals,
                        callback: function ($$v) {
                          _vm.$set(_vm.resource, "externals", $$v)
                        },
                        expression: "resource.externals",
                      },
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "noOptions" }, slot: "noOptions" },
                        [_vm._v("Aucune évaluation transmise")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { attrs: { slot: "maxElements" }, slot: "maxElements" },
                        [
                          _vm._v(
                            "Maximum de 2 options sélectionnées. Supprimez d'abord une option sélectionnée pour en sélectionner une autre."
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }